import { Component, Input, OnInit } from '@angular/core';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.pug',
  styleUrls: ['./footer.component.scss'],
  standalone: false
})
export class FooterComponent implements OnInit {
  @Input() billingFlow:any
  year;
  sd_10862_support_policy = false;
  constructor(private permissions: PermissionsService) { }
  ngOnInit(): void {
    this.year = new Date().getFullYear()
    this.sd_10862_support_policy = this.permissions.isFeatureActivated('sd-10862-support-policy');
  }

}
